import { render } from "./profile_edit.vue?vue&type=template&id=f2a0c2d2"
import script from "./profile_edit.vue?vue&type=script&lang=js"
export * from "./profile_edit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/user/profile/tabs/profile_edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2a0c2d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2a0c2d2', __exports__)) {
    console.log('reload')
    api.reload('f2a0c2d2', __exports__)
  }
  
  module.hot.accept("./profile_edit.vue?vue&type=template&id=f2a0c2d2", () => {
    console.log('re-render')
    api.rerender('f2a0c2d2', render)
  })

}


export default __exports__